import get from 'lodash.get';
import { trackEcommerce } from 'dibs-tracking';
import { defaultLocale } from 'dibs-intl/exports/constants';
import { pageTypeConstants as pageTypes } from '../../../constants/pageTypeConstants';
import { ECOMMERCE_ATTRIBUTES } from '../../../constants/attributesConstants';
import { cdnTestEcommerceTracking } from './cdnTestTracking';
import { PAGE_TYPE } from 'dibs-buyer-layout/exports/pageTypes';

const LIST_TRACKING_SEARCH = 'search results listing';
const LIST_TRACKING_BROWSE = 'browse page listing';
const LIST_TRACKING_ATTRIBUTE = 'attribute listing';
const LIST_TRACKING_STOREFRONT = 'storefront listing';
const LIST_TRACKING_BUY_PAGE = 'buy page';

import SV from 'server-vars';

export const NUMBER_OF_PRODUCT_IMPRESSIONS = 20;

const getListType = pageType => {
    const { SEARCH, BROWSE, DEALER } = pageTypes;

    if (pageType === SEARCH) {
        return LIST_TRACKING_SEARCH;
    } else if (pageType === BROWSE) {
        return LIST_TRACKING_BROWSE;
    } else if (ECOMMERCE_ATTRIBUTES.includes(pageType)) {
        return LIST_TRACKING_ATTRIBUTE;
    } else if (pageType === DEALER) {
        return LIST_TRACKING_STOREFRONT;
    } else if (pageType === PAGE_TYPE.BUY) {
        return LIST_TRACKING_BUY_PAGE;
    } else {
        return `${pageType} listing`;
    }
};

const getProductData = ({ index, item = {}, pageType }) => {
    const {
        serviceId,
        title,
        seller,
        displayPriceTracking,
        categoryCode,
        browseUrl,
        contemporaryTrackingString,
    } = item;

    let priceType = 'list price';

    const { convertedAmountList, type } = displayPriceTracking[0];

    if (type === 'SATURDAY_SALE') {
        priceType = 'saturday sale';
    } else if (type === 'NET') {
        priceType = 'net price';
    }

    const usdPrice = (convertedAmountList || []).find(({ currency }) => currency === 'USD') || {};
    const price = usdPrice.amount || 0;

    return {
        id: serviceId,
        name: SV.get('locale') === defaultLocale ? title : 'n/a',
        position: index + 1, // 1-indexed
        brand: get(seller, 'serviceId'),
        category: browseUrl,
        categoryCode,
        dimension76: priceType,
        dimension83: contemporaryTrackingString,
        price,
        list: getListType(pageType),
        ...cdnTestEcommerceTracking(),
    };
};

export const trackEcommerceProductImpressions = ({ items, pageType, startIndex = 0 }) => {
    const itemProductData = items
        .slice(startIndex, startIndex + NUMBER_OF_PRODUCT_IMPRESSIONS)
        .map(({ node }, index) =>
            getProductData({ item: node, pageType, index: startIndex + index })
        );

    trackEcommerce({
        type: 'productImpression',
        products: itemProductData,
    });
};

export const trackEcommerceProductClick = ({ item, pageType, index }) => {
    trackEcommerce({
        type: 'productClick',
        actionField: {
            list: getListType(pageType),
        },
        products: [getProductData({ item, pageType, index })],
    });
};

// TODO: FINDING-12480 make sure itemFragment below contains all
// information for every function that uses item in this file and
// remove fields from individual components

// export const itemFragment = graphql`
//     fragment ecommerceTracking_item on Item {
//         title
//         serviceId
//         categoryPath
//         contemporaryTrackingString
//         seller {
//             serviceId
//         }
//         displayInfo(buyerId: $userId) @include(if: $isClient) {
//             pricing {
//                 showNet
//                 showSale
//             }
//         }
//         pricing {
//             retailPrice {
//                 amount
//             }
//             netPrice {
//                 amount
//             }
//             salePrice {
//                 amount
//             }
//         }
//     }
// `;
